<template>
  <section class="is-full-height is-full-width" :data-e2e="SituationTestAttribute.view.SITUATIONS">
    <div v-if="hasEarlyExit" class="has-text-primary has-text-weight-semibold m-b-30">
      <span class="is-clickable is-size-3">{{ `<<` }}</span>
      <span
        class="m-l-5 is-clickable is-size-4 has-text-weight-semibold"
        @click="onEarlyExitClicked"
        :data-e2e="LightDiagnosticCypressAttribute.buttons.BACK_TO_SOLUTIONS"
      >
        {{ $t('lightdiagnostic.go-back-to-solutions') }}
      </span>
    </div>
    <h1 class="is-size-2 has-text-weight-semibold has-text-black m-b-10" :class="computedClass">
      {{ $t('lightdiagnostic.what-applies') }}
    </h1>
    <h2 class="subtitle has-text-black is-size-4 has-text-weight-medium">
      {{ $t('guidancestep.select-all-if-apply') }}
    </h2>
    <div class="columns m-t-10 is-multiline is-flex">
      <div class="column is-3" v-for="situation in SituationType.getValues()" :key="situation.key">
        <BoxButton
          class="is-full-height"
          @click="onClick(situation.key)"
          :selected="value.isSituationSelected(situation.key)"
          :centered="true"
        >
          <template #body>
            <div
              class="is-flex-direction-column is-flex-centered box-container"
              :data-e2e="SituationTestAttribute.buttons.SITUATION_TYPE_BUTTON"
            >
              <i
                :class="`cls cls-${situation.icon}`"
                class="has-text-secondary-grey is-size-1 m-b-10"
              ></i>
              <p class="is-size-5">{{ $t(situation.value) }}</p>
            </div>
          </template>
        </BoxButton>
      </div>
    </div>
    <BaseFlowControlButtons
      :next-disabled="false"
      :hide-back="hideBackButton"
      :show-press-enter="true"
      @next="customNext"
      @back="back"
    >
      <template #next>
        {{ $t('estatedistribution.continue') }}
      </template>
    </BaseFlowControlButtons>
  </section>
</template>

<script>
import { LightDiagnosticForm } from '@/modules/lightdiagnostic/models/LightDiagnosticForm';
import { SituationType } from '@/modules/situation/enums/SituationType';
import { SituationTestAttribute } from '@/modules/situation/constant/SituationTestAttribute';
import BoxButton from '@/modules/core/ui/components/BoxButton.vue';
import { FormCypressAttribute } from '@/modules/core/form/constants/FormCypressAttribute';
import BaseFlowControlButtons from '@/modules/core/form/components/BaseFlowControlButtons.vue';
import LightDiagnosticGoal from '@/modules/lightdiagnostic/components/presentational/LightDiagnosticGoal.vue';
import { LightDiagnosticMixin } from '@/modules/lightdiagnostic/mixins/LightDiagnosticMixin';
import { LightDiagnosticCypressAttribute } from '@/modules/lightdiagnostic/constants/LightDiagnosticCypressAttribute';

export default {
  compatConfig: {
    COMPONENT_V_MODEL: true
  },
  name: 'LightDiagnosticSituation',
  emits: ['on-back', 'flow-change', 'on-situations-input'],
  mixins: [LightDiagnosticMixin],
  components: { BaseFlowControlButtons, BoxButton },
  props: {
    value: {
      type: LightDiagnosticForm,
      required: true
    }
  },
  static: {
    LightDiagnosticCypressAttribute,
    SituationType,
    SituationTestAttribute,
    FormCypressAttribute
  },
  data() {
    return {
      form: this.value
    };
  },
  methods: {
    back() {
      this.$emit('on-back');
    },
    customNext() {
      this.$emit('flow-change', LightDiagnosticGoal);
    },
    onClick(situationKey) {
      this.form.addSituationKey(situationKey);
      this.$emit('on-situations-input', this.form.situations);
    },
    isSelected(situationKey) {
      return this.form.situations.includes(situationKey);
    }
  }
};
</script>

<style scoped>
:deep(.box-container) {
  min-height: rem(150px);
}

@media (min-width: 1024px) {
  .column.is-3 {
    width: 25% !important;
    flex: none !important;
  }
}

@media (max-width: 1215px) {
  .column.is-3 {
    width: 33% !important;
    flex: none !important;
  }
}

@media (max-width: 768px) {
  .column.is-3 {
    width: 100% !important;
    flex: none !important;
  }
}
</style>
